import { DashboardSlug } from '../types/reports.types'

export const DashboardTitle = {
  [DashboardSlug.FLOWCODE_ANALYSIS]: 'Flowcode Analysis',
  [DashboardSlug.FLOWPAGE_ANALYSIS]: 'Flowpage Analysis',
  [DashboardSlug.FLOWCODE_FLOWPAGE_ANALYSIS]: 'Flowcode <> Flowpage Analysis',
  [DashboardSlug.ADMIN_USAGE_REPORT]: 'Admin Usage Report',
  [DashboardSlug.FLOWCODE_RAW_EVENTS]: 'Flowcode Raw Events',
  [DashboardSlug.FLOWPAGE_RAW_EVENTS]: 'Flowpage Raw Events',
  [DashboardSlug.FLOWCODE_API_ANALYSIS]: 'Flowcode API Analysis'
}

export enum DashboardSendMessages {
  RUN = 'dashboard:run',
  STOP = 'dashboard:stop',
  LOAD = 'dashboard:load',
  OPTIONS = 'dashboard:options:set',
  FILTERS = 'dashboard:filters:update',
  SCHEDULE = 'dashboard:schedule_modal:open'
}

export enum DashboardFilters {
  TIMESTAMP = 'Scan Timestamp',
  NICKNAME = 'Flowcode Nickname',
  FOLDER = 'Folder Nickname',
  BATCH_ID = 'Flowcode ID'
}
